import { SingleDashboardItem } from "@components/pipelineNodes/PipelineNodeList.component";
import { DraftOnly } from "@components/project/DraftModeRequired.component";
import { useDashboards } from "@models/dashboard";
import PageStructure, { PageContent, PageContentHeader, PageContentInner, Pane, PaneContent } from "@pages/PageStructure.component";
import { useCallback, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const DashboardsListPage = () => {
    const [search, setSearch] = useState('');
    const { data: dashboards } = useDashboards();
    const navigate = useNavigate();

    const filteredDashboards = useMemo(() => {
        if (!dashboards) return [];
        return dashboards
            .filter(dashboard => 
                dashboard.name.toLowerCase().includes(search.toLowerCase()) ||
                dashboard.description?.toLowerCase().includes(search.toLowerCase())
            )
            .sort((a, b) => a.name.localeCompare(b.name));
    }, [dashboards, search]);

    return <PageStructure>
        <PageContent>
            <PageContentHeader>
                <div className="d-flex center-vertically">
                    <div style={{width:'40%'}}>
                        <h1 className="mb-0">Dashboards</h1>
                        <div className="text-muted font-13">Create and manage dashboards to visualize your data.</div>
                    </div>
                    <div className="flex-1 ps-5 pe-5">
                        <input 
                            type="text" 
                            className="form-control input-rounded input-search" 
                            placeholder="Search..." 
                            value={search} 
                            onChange={e => setSearch(e.target.value)}
                        />
                    </div>
                    <div>
                        <DraftOnly>
                            <Link to="/dashboards/new" className="btn btn-primary">
                                <i className="mdi mdi-plus-thick"></i> New Dashboard
                            </Link>
                        </DraftOnly>
                    </div>
                </div>
            </PageContentHeader>
            <PageContentInner hasHeader>
                <Pane>
                    <PaneContent>
                        <div className="p-4">
                            <div className="row g-3">
                                {filteredDashboards.map(dashboard => (
                                    <div key={dashboard.id} className="col-4">
                                        <SingleDashboardItem
                                            dashboard={dashboard}
                                            rounded
                                            onClick={() => navigate(`/dashboards/${dashboard.id}`)}
                                        />
                                    </div>
                                ))}
                                {filteredDashboards.length === 0 && (
                                    <div className="col-12 text-center text-muted py-5">
                                        {search ? (
                                            <>
                                                <i className="mdi mdi-file-search font-24 mb-2 d-block"></i>
                                                <p>No dashboards match your search.</p>
                                            </>
                                        ) : (
                                            <>
                                                <i className="mdi mdi-view-dashboard font-24 mb-2 d-block"></i>
                                                <p>No dashboards yet. Create your first dashboard to get started.</p>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </PaneContent>
                </Pane>
            </PageContentInner>
        </PageContent>
    </PageStructure>
};

export default DashboardsListPage;